import axios from "axios";
import { store } from "Root";

import { login } from "store/modules/common/loginReducer";

import { loginInfo } from "bridge/common/CommonBridge";
import Constants from "../common/Constants";
import { callPost } from "./CommonApi";
import moment from "moment";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";

export const getRedisContext = (callAutoLogin) => {
    axios
        .get("/common/getRedisContext")
        .then((response) => {
            const loginData = response.data;
            if (Boolean(loginData.MMBR_SEQ) && Boolean(loginData.MMBR_ID)) {
                if (callAutoLogin) {
                    if (loginData.PAUSE_YN === "Y") {
                        return;
                    }
                    callAutoLogin(loginData.MMBR_ID, loginData.TOKEN);
                }

                const headerParam = {
                    user_id: loginData.MMBR_ID,
                };

                const queryParam = {
                    MMBR_SEQ: loginData.MMBR_SEQ,
                };
                const param = {
                    REQUEST_API: Constants.SET_GRADE_API.GET_GRADE_INFO,
                    HTTP_METHOD: Constants.HTTP_METHOD.GET,
                };

                callPost(
                    headerParam,
                    param,
                    (res) => {
                        const gradeInfo = res?.RESP_RESULT?.GRAD_CD;
                        console.log("***GET_GRAD_CD: ", gradeInfo);
                        console.log("loginData.LOGIN_TYPE : ", loginData.LOGIN_TYPE);
                        store.dispatch(
                            login({
                                signedIn: true,
                                mmbrSeq: loginData.MMBR_SEQ,
                                mmbrName: loginData.MMBR_NAME,
                                contractNumber: loginData.CONTRACT_NUMBER,
                                customerNumber: loginData.CUSTOMER_NUMBER,
                                userId: loginData.MMBR_ID,
                                gradCd: gradeInfo || loginData.GRAD_CD,
                                pedcCd: loginData.PEDC_CD,
                                authCode: loginData.AUTH_CODE,
                                mmbrJoinDt: loginData.MMBR_JOIN_DT,
                                homeSchoolYn: loginData.HOMESCHOOL_YN || "N",
                                subscriberType: loginData.SUBSCRIBER_TYPE,
                                token: loginData.TOKEN,
                                servicePlatform: loginData.SERVICE_FLATFORM,
                                loginType: loginData.LOGIN_TYPE,
                            }),
                        );

                        document.cookie = "SIGN_IN=SIGN_IN";
                        loginInfo(loginData);
                    },
                    queryParam,
                );
            } else {
                const { cookie } = loginData;
                const now = moment();
                const expires = moment(cookie.expires); // 쿠키 만료일(ex. 2024-12-26T08:42:23.450Z)

                // auto 로그인 경우 예외처리
                // if (callAutoLogin && typeof callAutoLogin === "function") return;

                if (now.isAfter(expires)) {
                    // 만료일이 지났을 경우
                    AlertConfirmPopup({
                        type: "ALERT",
                        msg: Constants.ERROR_MESSAGE.EXPIRED_DEVICE_DATE,
                    });
                }
            }
        })
        .catch((error) => {
            //another Error Exception
            console.error(error);
        });
};
